import { render, staticRenderFns } from "./ClassManagement.vue?vue&type=template&id=6562bdd8"
import script from "./ClassManagement.vue?vue&type=script&lang=js"
export * from "./ClassManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports